/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import util from "../../../../../../../utils/es5Utils";
import { mapIcon } from "../../../../v1/blocks/WidgetValues/Map";


function defineBlock(context) {
    return {
        init: function () {
            let selectMapDropdown = new Blockly.FieldWidgetsDropdown(context, 'map', undefined, '- select -');

            this.appendDummyInput('WIDGET')
                .appendField('add to')
                .appendField(new Blockly.FieldImage(mapIcon, 30, 30, 'map icon', null), 'mapIcon')
                .appendField(selectMapDropdown, 'ID');

            this.appendValueInput('LATITUDE')
                .appendField('marker with coordinates')
                .setCheck("Number");

            this.appendValueInput('LONGITUDE')
                .setCheck("Number");

            this.appendValueInput('WIDGET_COLOR')
                .appendField(', color')
                .setCheck("Colour");

            this.appendValueInput('MARKER_ID')
                .appendField('with marker ID')
                .setCheck("String");

            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, "String");
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Add a marker to a map and return its marker ID. Leave the marker ID empty to generate one automatically.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#maps`);
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let mapId = block.getFieldValue('ID');
            let latitude = Blockly.JavaScript.valueToCode(block, 'LATITUDE', Blockly.JavaScript.ORDER_FUNCTION_CALL);
            let longitude = Blockly.JavaScript.valueToCode(block, 'LONGITUDE', Blockly.JavaScript.ORDER_FUNCTION_CALL);
            let color = Blockly.JavaScript.valueToCode(block, 'WIDGET_COLOR', Blockly.JavaScript.ORDER_NONE);
            let markerId = Blockly.JavaScript.valueToCode(block, 'MARKER_ID', Blockly.JavaScript.ORDER_NONE) || "''";
            let code = `Snap.widgets.map.addMarker('${mapId}', ${latitude}, ${longitude}, ${color}, ${markerId})`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const AddMarker = function (props) {
    const name = 'snap_map_add_marker_V3';
    AddMarker.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return util.widgetsOfType(props.context, "map").length ?
    <block type={name}>
        <value name="LATITUDE">
            <shadow type="math_number"></shadow>
        </value>
        <value name="LONGITUDE">
            <shadow type="math_number"></shadow>
        </value>
        <value name="WIDGET_COLOR">
            <shadow type="colour_picker">
                <field name="COLOUR">#FF0000</field>
            </shadow>
        </value>
        <value name="MARKER_ID">
            <shadow type="fixed_width_text">
                <mutation length="9"></mutation>
            </shadow>
        </value>
    </block> :
    null;
}

AddMarker.propTypes = {
    context: PropTypes.object
};

export default AddMarker;
